import type { ReactNode } from "react";
import "./FilteredOutWarning.scss";
import { useTranslation } from "react-i18next";
import useScheduleViewFilters from "@/pages/human-resources/time-management/components/display-filters/provider/useScheduleViewFilters.ts";
import useSchedulesManager from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useSchedulesManager.ts";

export default function FilteredOutWarning(): ReactNode {
  const schedulesManager = useSchedulesManager();
  const {
    state: { filteredOutEntities },
  } = useScheduleViewFilters();
  const hasHiddenEmployees = schedulesManager
    .listSchedules()
    .some((es) => !filteredOutEntities.shouldShowEmployeeSchedules(es));
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement",
  });
  return (
    hasHiddenEmployees && (
      <div className="filtered-out-warning">
        {t("scheduleAlerts.filteredOutWarning")}
      </div>
    )
  );
}
